import {
  getPlatformV1OpsExchangeRates,
  putPlatformV1OpsExchangeRates,
  type GetPlatformV1OpsExchangeRates200,
  type PutPlatformV1OpsExchangeRates200,
  type PutPlatformV1OpsExchangeRatesBody,
} from '@nucleus-commerce/api-client/platform';

/** Bounded `{ items }` list: the newest rate per currency pair. PUT appends and answers the same shape. */
export const exchangeRatesApi = {
  list: (): Promise<GetPlatformV1OpsExchangeRates200> => getPlatformV1OpsExchangeRates(),
  put: (input: PutPlatformV1OpsExchangeRatesBody): Promise<PutPlatformV1OpsExchangeRates200> =>
    putPlatformV1OpsExchangeRates(input),
};
